let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iNh8a")).then(() => parcelRequire('5y4bu'));